import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { handleEntityActions } from '../../modules/mockEntityActions'
import { requireAuthenticatedUser } from '../../decorators'

/**
 * `POST /api/transactions` — the transactional write, the one route every
 * actions payload goes to.
 *
 * Signing a contract writes four entity types — contract, order,
 * orderMasterService, orderMSService — and used to go out as a PATCH plus an
 * unawaited `POST /api/orders/overview`, with no way to undo the PATCH when the
 * POST failed. Here every action names its own entity and
 * `api/msw/modules/entityActionsRegistry.ts` resolves it, so the whole
 * signature lands or none of it does. The msService options edit comes here
 * too; its per-collection `/api/<silo>msservices/actions` routes are retired
 * (#1627 phase B).
 *
 * The real one is cynque-api-server #1595, renamed from `/api/actions` by
 * #1627 phase A. It answers **200**: a transaction of only updates creates
 * nothing, and several creates have no primary resource to name.
 */
const postEntityActions = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  // The registry is the boundary — an unregistered entity is a 422.
  return handleEntityActions(req, res, ctx, {
    operationType: 'POST /api/transactions',
  })
}

export const handlers = [
  {
    method: 'post',
    path: '/api/transactions',
    handler: postEntityActions,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
